// Product page sitewide sale prices. The theme writes the variant's price into [data-price-wrapper]
// on load and on every variant change, then fires theme:variant:change; this writes the sale price
// over it while a sale is live. Sales and variant prices come from the JSON in
// snippets/sitewide-sale-product.liquid.
(() => {
  if (window.sitewideSaleProduct) return;
  window.sitewideSaleProduct = true;

  const format = (cents) => {
    const currency = window.theme?.currency;
    const useCode = window.theme?.settings?.currency_code_enable;
    const pattern = (useCode ? window.theme?.moneyWithCurrencyFormat : window.theme?.moneyFormat) || '${{amount}}';
    if (currency?.formatMoney) return currency.formatMoney(cents, pattern);

    const amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return pattern.replace(/\{\{\s*\w+\s*\}\}/, amount);
  };

  const liveSale = (sales) => {
    const now = Date.now() / 1000;
    return sales.find((sale) => now >= sale.starts && (sale.ends === 0 || now < sale.ends));
  };

  const apply = (wrapper, variantId) => {
    const json = wrapper.querySelector('[data-sitewide-sale]');
    const priceEl = wrapper.querySelector('[data-product-price]');
    const compareEl = wrapper.querySelector('[data-compare-price]');
    if (!json || !priceEl || !compareEl) return;

    const data = JSON.parse(json.textContent);
    const variant = data.variants[variantId];
    const sale = variant && variant.compare <= variant.price && variant.price > 0 ? liveSale(data.sales) : null;

    if (sale) {
      const salePrice = variant.price - Math.round((variant.price * sale.percentage) / 100);
      priceEl.innerHTML = format(salePrice);
      priceEl.classList.add('product__price--sale');
      compareEl.innerHTML = format(variant.price);
      compareEl.classList.remove('hidden');
      wrapper.dataset.sitewideSaleApplied = '';
    } else if ('sitewideSaleApplied' in wrapper.dataset && variant) {
      priceEl.innerHTML = format(variant.price);
      priceEl.classList.toggle('product__price--sale', variant.compare > variant.price);
      compareEl.innerHTML = variant.compare > variant.price ? format(variant.compare) : '';
      compareEl.classList.toggle('hidden', !(variant.compare > variant.price));
      delete wrapper.dataset.sitewideSaleApplied;
    }
  };

  const selectedVariant = (wrapper) => {
    const scope = wrapper.closest('[data-product], .shopify-section') || document;
    return scope.querySelector('[data-product-form] [name="id"], form[action*="/cart/add"] [name="id"]')?.value;
  };

  const applyAll = () => {
    document.querySelectorAll('[data-price-wrapper]').forEach((wrapper) => apply(wrapper, selectedVariant(wrapper)));
  };

  document.addEventListener('theme:variant:change', (event) => {
    const variantId = event.detail?.variant?.id;
    if (!variantId) return;
    event.target.querySelectorAll('[data-price-wrapper]').forEach((wrapper) => apply(wrapper, String(variantId)));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
})();
